import React from 'react';

import { OpenRowButton } from '../HomeSection';

import { moneyFigure } from './rowBadges';

/**
 * The user's opportunities.
 *
 * TWO COLUMNS, AND NO TOTAL UNDER THEM. An opportunity carries a name, a
 * description, a value and an owner and nothing else — no status, no target
 * date — so any further column could only render blank. The per-row value is
 * the opportunity's own; a sum across the list is not something Home is allowed
 * to show.
 *
 * NO TILE OPENS THIS ONE any more, and the table stays: the type is still
 * served by the section endpoint and still reachable from its own module.
 */
export default function OpportunitySectionTable({ rows = [], onRowClick }) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th>{$t('Description')}</th>
                        <th className="tw-w-40">{$t('Value')}</th>
                    </tr>
                </thead>
                <tbody>
                    {rows.map((row) => (
                        <tr key={row.id} onClick={() => onRowClick?.(row)} className="tw-cursor-pointer">
                            <td>
                                <OpenRowButton onClick={() => onRowClick?.(row)} label={$t('Open {{item}}', { item: row.description })}>
                                    {row.description}
                                </OpenRowButton>
                            </td>
                            <td className="inbud-numeric-cell">{moneyFigure(row.value)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}
